import React from 'react';
import OrganizationImages from '../../LinkPreview/components/OrganizationImages';
import { connect } from 'react-redux';
import { setSelectedDesign } from '../../../redux/actions/linkPreview';

const OrganizationImagesWrapper = ({ selectedDesign }) => {
  return (
    <div>
        <OrganizationImages />
    </div>
  );
};

const mapStateToProps = (state) => ({
  selectedDesign: state.linkPreview.selectedDesign.design
});

const mapDispatchToProps = (dispatch) => ({
  setSelectedDesign: (design) => dispatch(setSelectedDesign(design))
});

export default connect(mapStateToProps, mapDispatchToProps)(OrganizationImagesWrapper); 